export function getCurrentDateInMs(): number {
	return Date.now();
}
